import { render } from "./BackgroundGrid.vue?vue&type=template&id=25ace322"
import script from "./BackgroundGrid.vue?vue&type=script&lang=js"
export * from "./BackgroundGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__